import Contacts from '../../pages/Contacts/Contacts';
import Dashboard from '../../pages/Dashboard/Dashboard';
import Prices from '../../pages/Prices/Prices';
import { catalog_routes } from './Catalogs/catalogs-routes';
import { companies_routes } from './Companies/companies-routes';
import { managers_routes } from './Managers/managers-routes';
import { profile_routes } from './Profile/profile-routes';
import { orders_routes } from './Orders/orders-routes';
import Cart from '../../pages/Cart/Cart';
import { PriceView } from '../../widgets/price-view';
import { PdfAddViewer } from '../../widgets/pdf-add-viewer';
import Devices from '../../pages/Devices/Devices';
import ProtectedRoute from './ProtectedRoute';
import Issue from '../../pages/Issue/Issue';
import Helpdesk from '../../pages/Helpdesk/Helpdesk';
import HelpdeskTicket from '../../pages/HelpdeskTicket/HelpdeskTicket';
import Reports from '../../pages/Reports/Reports';
import NotFound from '../../pages/NotFound/NotFound';
import Settings from '../../pages/Settings/Settings';
import RoutingSettings from '../../pages/Settings/sections/RoutingSettings';
import SLASettings from '../../pages/Settings/sections/SLASettings';
import TicketTypeSettings from '../../pages/Settings/sections/TicketTypeSettings';
import StatusCloseSettings from '../../pages/Settings/sections/StatusCloseSettings';
import ScheduleSettings from '../../pages/Settings/sections/ScheduleSettings';
import NotificationSettings from '../../pages/Settings/sections/NotificationSettings';
import EmailChannelSettings from '../../pages/Settings/sections/EmailChannelSettings';
import UsersRolesSettings from '../../pages/Settings/sections/UsersRolesSettings';
import ProfileSettings from '../../pages/Settings/sections/ProfileSettings';
import SecuritySettings from '../../pages/Settings/sections/SecuritySettings';
import { Navigate } from 'react-router-dom';

export const routes = [
  {
    path: '/',
    element: <Dashboard />,
    loader: () => {
      return (document.title = 'Главная');
    },
  },
  {
    path: 'cart',
    element: (
      <ProtectedRoute
        redirectTo={'/'}
        action={'view'}
        subject={'cart'}
        children={<Cart />}
      />
    ),
    loader: () => {
      return (document.title = 'Корзина');
    },
  },
  {
    path: 'prices',
    element: (
      <ProtectedRoute
        redirectTo={'/'}
        action={'view'}
        subject={'pricelist'}
        children={<Prices />}
      />
    ),
    loader: () => {
      return (document.title = 'Прайсы');
    },
  },
  {
    path: 'prices/:id',
    element: (
      <ProtectedRoute
        redirectTo={'/'}
        action={'view'}
        subject={'pricelist'}
        children={<PriceView />}
      />
    ),
    loader: () => {
      return (document.title = 'Прайс');
    },
  },
  {
    path: 'prices/add',
    element: (
      <ProtectedRoute
        redirectTo={'/prices'}
        action={'add'}
        subject={'pricelist'}
        children={<PdfAddViewer />}
      />
    ),

    loader: () => {
      return (document.title = 'Добавление прайса');
    },
  },
  {
    path: 'prices/edit/:id',
    element: (
      <ProtectedRoute
        redirectTo={'/prices'}
        action={'view'}
        subject={'pricelist'}
        children={<PdfAddViewer />}
      />
    ),
    loader: () => {
      return (document.title = 'Изменение прайса');
    },
  },
  {
    path: 'contacts',
    element: <Contacts />,
    loader: () => {
      return (document.title = 'Контакты');
    },
  },
  {
    path: 'devices',
    element: (
      <ProtectedRoute
        children={<Devices />}
        redirectTo={'/'}
        action={'viewdevices'}
        subject={'username'}
      />
    ),
    loader: () => {
      return (document.title = 'Устройства');
    },
  },
  {
    path: 'issues/:id',
    element: (
      <ProtectedRoute
        children={<Issue />}
        redirectTo={'/'}
        action={'viewdevices'}
        subject={'username'}
      />
    ),
    loader: () => {
      return (document.title = 'Заявка ');
    },
  },
  {
    path: 'helpdesk',
    element: <Helpdesk />,
    loader: () => {
      return (document.title = 'Helpdesk');
    },
  },
  {
    path: 'helpdesk/:id',
    element: <HelpdeskTicket />,
    loader: () => {
      return (document.title = 'Заявка');
    },
  },
  {
    path: 'reports',
    element: (
      <ProtectedRoute
        redirectTo={'/helpdesk'}
        action={'hd_view_reports'}
        subject={'ticket'}
        children={<Reports />}
      />
    ),
    loader: () => {
      return (document.title = 'Отчёты');
    },
  },
  {
    path: 'settings',
    element: <Settings />,
    loader: () => {
      return (document.title = 'Настройки');
    },
    children: [
      // Дефолт — «Профиль». Это первый пункт, доступный каждому юзеру.
      { index: true, element: <Navigate to="profile" replace /> },
      { path: 'profile', element: <ProfileSettings /> },
      { path: 'security', element: <SecuritySettings /> },
      { path: 'users', element: <UsersRolesSettings /> },
      { path: 'helpdesk/routing', element: <RoutingSettings /> },
      { path: 'helpdesk/sla', element: <SLASettings /> },
      { path: 'helpdesk/ticket-types', element: <TicketTypeSettings /> },
      { path: 'helpdesk/statuses', element: <StatusCloseSettings /> },
      { path: 'helpdesk/schedules', element: <ScheduleSettings /> },
      { path: 'helpdesk/notifications', element: <NotificationSettings /> },
      { path: 'helpdesk/email-channel', element: <EmailChannelSettings /> },
    ],
  },
  ...profile_routes,
  ...managers_routes,
  ...catalog_routes,
  ...companies_routes,
  ...orders_routes,
];
